/* ════════════════════════════════════════════════════════════════════
   VCZ LOCKET CROP — asset do tema (assets/vcz-locket-crop.js)
   Editor de enquadramento das fotos interiores dos relicários.

   O cliente arrasta / faz zoom / roda a foto dentro da forma EXATA da
   cavidade do relicário. O resultado é guardado em MILÍMETROS relativos
   ao centro da forma — o servidor (server/locket_pdf.py) usa exatamente
   a mesma matemática para gerar o PDF A4 à escala real.

   Formas: geradas a partir de lockets/shapes.json por lockets/build_shapes.py
   (NÃO editar o bloco SHAPES à mão).

   API:
     const ctl = VCZLocketCrop.mount(container, { shape, mirror, file, onChange, onError })
     ctl.get()      → { v, shape, mirror, x, y, w, rot, nw, nh } (mm) ou null se a imagem não carregou
     ctl.destroy()
   ════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* @@SHAPES_START@@ */
  var SHAPES = {"round":{"scale":0.96,"pts":[[5.475,0.012],[5.435,0.297],[5.424,0.582],[5.371,0.863],[5.303,1.139],[5.237,1.415],[5.17,1.691],[5.106,1.972],[5.044,2.258],[4.947,2.533],[4.852,2.813],[4.735,3.087],[4.628,3.374],[4.484,3.643],[4.343,3.922],[4.165,4.176],[3.972,4.423],[3.756,4.65],[3.547,4.893],[3.3,5.093],[3.032,5.262],[2.755,5.419],[2.474,5.567],[2.192,5.721],[1.89,5.829],[1.595,5.962],[1.287,6.066],[0.974,6.162],[0.655,6.241],[0.329,6.293],[0.0,6.333],[-0.332,6.349],[-0.664,6.332],[-0.996,6.304],[-1.334,6.29],[-1.673,6.255],[-2.019,6.226],[-2.361,6.163],[-2.695,6.066],[-3.042,5.982],[-3.382,5.871],[-3.724,5.747],[-4.051,5.588],[-4.368,5.406],[-4.664,5.192],[-4.941,4.953],[-5.192,4.687],[-5.395,4.381],[-5.503,4.01],[-5.549,3.616],[-5.569,3.227],[-5.568,2.849],[-5.568,2.491],[-5.566,2.149],[-5.567,1.821],[-5.569,1.504],[-5.569,1.196],[-5.569,0.894],[-5.569,0.597],[-5.57,0.304],[-5.577,0.012],[-5.57,-0.28],[-5.569,-0.574],[-5.558,-0.868],[-5.53,-1.164],[-5.528,-1.469],[-5.528,-1.785],[-5.53,-2.111],[-5.529,-2.45],[-5.53,-2.806],[-5.475,-3.149],[-5.384,-3.485],[-5.236,-3.792],[-5.044,-4.073],[-4.822,-4.33],[-4.581,-4.569],[-4.329,-4.797],[-4.069,-5.013],[-3.797,-5.215],[-3.505,-5.386],[-3.218,-5.562],[-2.91,-5.701],[-2.598,-5.823],[-2.286,-5.943],[-1.975,-6.067],[-1.655,-6.166],[-1.327,-6.235],[-0.995,-6.269],[-0.665,-6.317],[-0.333,-6.348],[0.0,-6.353],[0.331,-6.298],[0.654,-6.213],[0.972,-6.123],[1.28,-6.01],[1.585,-5.902],[1.874,-5.756],[2.157,-5.606],[2.43,-5.444],[2.698,-5.283],[2.965,-5.123],[3.219,-4.944],[3.447,-4.732],[3.68,-4.532],[3.884,-4.302],[4.085,-4.073],[4.267,-3.83],[4.461,-3.6],[4.644,-3.362],[4.825,-3.121],[4.98,-2.863],[5.131,-2.602],[5.249,-2.325],[5.363,-2.047],[5.462,-1.763],[5.545,-1.474],[5.576,-1.173],[5.569,-0.87],[5.564,-0.573],[5.497,-0.276]],"notch":{"x":6.007,"y":-0.103,"r":1.639,"on":"mirror"}},"heart":{"scale":0.96,"pts":[[5.665,-0.022],[5.533,0.269],[5.424,0.551],[5.271,0.816],[5.132,1.074],[4.997,1.323],[4.846,1.559],[4.697,1.789],[4.534,2.006],[4.346,2.203],[4.191,2.41],[4.027,2.607],[3.851,2.791],[3.706,2.996],[3.534,3.178],[3.353,3.352],[3.18,3.532],[3.003,3.712],[2.828,3.899],[2.643,4.079],[2.455,4.265],[2.26,4.454],[2.051,4.632],[1.838,4.821],[1.619,5.023],[1.382,5.212],[1.132,5.401],[0.87,5.602],[0.59,5.785],[0.294,5.971],[-0.02,6.1],[-0.343,6.134],[-0.658,6.045],[-0.964,5.939],[-1.257,5.797],[-1.533,5.624],[-1.797,5.445],[-2.05,5.265],[-2.291,5.078],[-2.517,4.879],[-2.749,4.704],[-2.963,4.51],[-3.165,4.307],[-3.377,4.123],[-3.575,3.926],[-3.772,3.73],[-3.968,3.533],[-4.168,3.337],[-4.365,3.135],[-4.569,2.932],[-4.753,2.711],[-4.959,2.495],[-5.16,2.267],[-5.346,2.023],[-5.521,1.766],[-5.674,1.493],[-5.774,1.201],[-5.872,0.905],[-5.944,0.601],[-5.985,0.291],[-6.01,-0.022],[-6.024,-0.336],[-6.035,-0.654],[-6.063,-0.979],[-6.064,-1.306],[-6.063,-1.641],[-6.067,-1.986],[-6.073,-2.345],[-6.103,-2.73],[-6.085,-3.112],[-6.065,-3.511],[-6.066,-3.947],[-6.029,-4.387],[-5.947,-4.821],[-5.762,-5.191],[-5.49,-5.491],[-5.169,-5.74],[-4.811,-5.938],[-4.414,-6.069],[-3.986,-6.128],[-3.555,-6.143],[-3.109,-6.083],[-2.62,-5.861],[-2.172,-5.628],[-1.787,-5.458],[-1.424,-5.259],[-1.115,-5.173],[-0.825,-5.1],[-0.554,-5.102],[-0.291,-5.176],[-0.02,-5.243],[0.257,-5.316],[0.551,-5.457],[0.855,-5.55],[1.183,-5.682],[1.525,-5.788],[1.894,-5.914],[2.278,-6.01],[2.676,-6.077],[3.099,-6.144],[3.484,-6.092],[3.848,-5.978],[4.206,-5.838],[4.551,-5.667],[4.862,-5.444],[5.139,-5.181],[5.393,-4.896],[5.605,-4.577],[5.773,-4.231],[5.911,-3.874],[6.013,-3.505],[6.084,-3.132],[6.102,-2.747],[6.101,-2.371],[6.101,-2.011],[6.102,-1.662],[6.058,-1.314],[5.983,-0.973],[5.876,-0.641],[5.775,-0.325]],"notch":{"x":6.462,"y":-2.082,"r":1.639,"on":"mirror"}},"star":{"scale":0.96,"pts":[[4.048,0.003],[3.892,0.205],[3.748,0.394],[3.628,0.574],[3.541,0.751],[3.473,0.928],[3.429,1.11],[3.398,1.299],[3.413,1.513],[3.484,1.767],[3.547,2.038],[3.631,2.347],[3.696,2.673],[3.756,3.027],[3.818,3.421],[3.833,3.814],[3.788,4.186],[3.696,4.54],[3.545,4.852],[3.439,5.266],[3.041,5.233],[2.685,5.23],[2.346,5.223],[1.996,5.148],[1.653,5.023],[1.335,4.904],[1.036,4.778],[0.759,4.659],[0.501,4.569],[0.257,4.493],[0.021,4.455],[-0.212,4.461],[-0.453,4.514],[-0.715,4.65],[-1.012,4.865],[-1.343,5.096],[-1.712,5.336],[-2.106,5.544],[-2.499,5.664],[-2.964,5.863],[-3.468,6.047],[-3.837,5.943],[-3.9,5.4],[-3.846,4.778],[-3.874,4.329],[-3.954,3.978],[-3.968,3.594],[-3.927,3.2],[-3.889,2.843],[-3.805,2.488],[-3.781,2.198],[-3.782,1.941],[-3.815,1.711],[-3.889,1.503],[-4.008,1.312],[-4.203,1.135],[-4.43,0.949],[-4.726,0.755],[-4.996,0.53],[-5.303,0.282],[-5.645,0.003],[-5.917,-0.309],[-6.076,-0.638],[-6.114,-0.969],[-6.094,-1.297],[-5.818,-1.562],[-5.416,-1.764],[-4.978,-1.917],[-4.595,-2.053],[-4.222,-2.16],[-3.896,-2.259],[-3.602,-2.35],[-3.3,-2.41],[-3.031,-2.469],[-2.813,-2.549],[-2.688,-2.707],[-2.658,-2.973],[-2.644,-3.289],[-2.572,-3.567],[-2.477,-3.845],[-2.38,-4.156],[-2.267,-4.489],[-2.139,-4.849],[-1.963,-5.168],[-1.754,-5.461],[-1.529,-5.782],[-1.253,-5.994],[-0.932,-6.018],[-0.58,-5.718],[-0.265,-5.466],[0.021,-5.201],[0.276,-4.863],[0.503,-4.58],[0.708,-4.33],[0.897,-4.117],[1.072,-3.919],[1.236,-3.736],[1.395,-3.575],[1.56,-3.454],[1.731,-3.354],[1.927,-3.298],[2.146,-3.269],[2.396,-3.266],[2.667,-3.265],[2.954,-3.254],[3.269,-3.245],[3.607,-3.225],[4.004,-3.222],[4.57,-3.302],[5.303,-3.427],[5.842,-3.358],[6.008,-3.048],[6.085,-2.697],[6.117,-2.337],[6.115,-1.977],[5.464,-1.456],[4.886,-1.031],[4.623,-0.726],[4.399,-0.458],[4.223,-0.218]]}};
  var BLEED_MM = 1.0;
  /* @@SHAPES_END@@ */

  var MIN_DPI  = 200;   /* abaixo disto avisa que a foto pode ficar desfocada */
  var MAX_ZOOM = 4;     /* zoom máximo relativo ao mínimo que cobre a forma */
  var VIEW_PAD = 1.35;  /* área visível do editor = forma × VIEW_PAD */

  /* ── Geometria (espelhada em server/locket_pdf.py) ───────────────── */
  function shapePts(key, mirror) {
    var s = SHAPES[key];
    if (!s) return null;
    return s.pts.map(function (p) { return [(mirror ? -p[0] : p[0]) * s.scale, p[1] * s.scale]; });
  }
  /* Entalhe tracejado a recortar (só na forma onde 'on' corresponde) → [cx, cy, r] ou null. */
  function shapeNotch(key, mirror) {
    var s = SHAPES[key], n = s && s.notch;
    if (!n || (n.on === 'mirror') !== !!mirror) return null;
    return [(mirror ? -n.x : n.x) * s.scale, n.y * s.scale, n.r * s.scale];
  }
  /* Offset radial: as formas são star-convex a partir do centro. */
  function offsetPts(P, d) {
    return P.map(function (p) {
      var r = Math.hypot(p[0], p[1]) || 1;
      var k = (r + d) / r;
      return [p[0] * k, p[1] * k];
    });
  }
  function bbox(P) {
    var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    P.forEach(function (p) { x0 = Math.min(x0, p[0]); y0 = Math.min(y0, p[1]); x1 = Math.max(x1, p[0]); y1 = Math.max(y1, p[1]); });
    return { x0: x0, y0: y0, x1: x1, y1: y1, w: x1 - x0, h: y1 - y0 };
  }
  /* Catmull-Rom fechada → beziers cúbicas (mesma fórmula no servidor). */
  function pathD(P) {
    var n = P.length, f = function (v) { return v.toFixed(3); };
    var d = 'M' + f(P[0][0]) + ' ' + f(P[0][1]);
    for (var i = 0; i < n; i++) {
      var p0 = P[(i - 1 + n) % n], p1 = P[i], p2 = P[(i + 1) % n], p3 = P[(i + 2) % n];
      d += 'C' + f(p1[0] + (p2[0] - p0[0]) / 6) + ' ' + f(p1[1] + (p2[1] - p0[1]) / 6) + ' ' +
                 f(p2[0] - (p3[0] - p1[0]) / 6) + ' ' + f(p2[1] - (p3[1] - p1[1]) / 6) + ' ' +
                 f(p2[0]) + ' ' + f(p2[1]);
    }
    return d + 'Z';
  }

  /* ── Estilos (injetados uma vez; o .liquid está no limite de 256 KB) ── */
  var CSS =
    '.vlc{margin:0 0 10px}' +
    '.vlc-stage{position:relative;width:100%;max-width:300px;aspect-ratio:1/1;margin:0 auto;overflow:hidden;background:#f1f1f1;border-radius:6px;touch-action:none;cursor:grab;user-select:none;-webkit-user-select:none}' +
    '.vlc-stage:active{cursor:grabbing}' +
    /* !important: o tema aplica a .vcz-upload-preview img { max-height:200px; object-fit:cover } — cortava a foto no zoom */
    '.vlc .vlc-img{position:absolute;left:50%;top:50%;max-width:none!important;max-height:none!important;min-width:0!important;height:auto!important;object-fit:fill!important;margin:0!important;transform-origin:50% 50%;pointer-events:none;-webkit-user-drag:none}' +
    '.vlc-ov{position:absolute;inset:0;width:100%;height:100%;pointer-events:none}' +
    '.vlc-bar{display:flex;align-items:center;gap:10px;max-width:300px;margin:10px auto 0}' +
    '.vlc-zoom{flex:1;accent-color:#0E1E37}' +
    '.vlc-rot{flex:none;border:1px solid #d6d6d6;background:#fff;border-radius:4px;width:36px;height:32px;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#0E1E37}' +
    '.vlc-hint{font-size:11px;color:#777;text-align:center;margin:6px 0 0}' +
    '.vlc-warn{font-size:12px;color:#9a5b00;background:#fff6e5;border-radius:4px;padding:6px 8px;margin:8px auto 0;max-width:300px}';
  function injectCss() {
    if (document.getElementById('vlc-css')) return;
    var st = document.createElement('style');
    st.id = 'vlc-css';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function mount(container, opts) {
    injectCss();
    var cut = shapePts(opts.shape, !!opts.mirror);
    if (!cut) { if (opts.onError) opts.onError('Unknown locket shape: ' + opts.shape); return null; }
    var bleed = offsetPts(cut, BLEED_MM);
    var bb = bbox(bleed);
    var V = Math.max(bb.w, bb.h) * VIEW_PAD;           /* lado da vista, em mm */
    var notch = shapeNotch(opts.shape, !!opts.mirror);
    var clipId = 'vlc-clip-' + Math.random().toString(36).slice(2);
    function notchSvg() {                 /* entalhe a tracejado, só dentro da forma (como no PDF) */
      if (!notch) return '';
      return '<clipPath id="' + clipId + '"><path d="' + pathD(cut) + '"/></clipPath>' +
        '<circle cx="' + notch[0] + '" cy="' + notch[1] + '" r="' + notch[2] + '" fill="none" stroke="#0E1E37" ' +
        'stroke-width="' + (V / 300) + '" stroke-dasharray="' + (V / 120) + ' ' + (V / 140) + '" clip-path="url(#' + clipId + ')"/>';
    }

    container.innerHTML =
      '<div class="vlc">' +
        '<div class="vlc-stage">' +
          '<img class="vlc-img" alt="" draggable="false">' +
          '<svg class="vlc-ov" viewBox="' + (-V / 2) + ' ' + (-V / 2) + ' ' + V + ' ' + V + '" preserveAspectRatio="xMidYMid meet">' +
            '<path fill="rgba(255,255,255,.78)" fill-rule="evenodd"/>' +
            '<path fill="none" stroke="#0E1E37" stroke-width="' + (V / 300) + '"/>' +
            notchSvg() +
          '</svg>' +
        '</div>' +
        '<div class="vlc-bar">' +
          '<input class="vlc-zoom" type="range" min="1" max="' + MAX_ZOOM + '" step="0.01" value="1" aria-label="' + ((window.vczI18n&&window.vczI18n['crop.zoom_html'])||'Zoom') + '">' +
          '<button type="button" class="vlc-rot" aria-label="' + ((window.vczI18n&&window.vczI18n['crop.rotate_html'])||'Rotate 90°') + '"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M13 8a5 5 0 1 1-1.5-3.6M13 2.5v2.5h-2.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '</div>' +
        '<p class="vlc-hint">' + ((window.vczI18n&&window.vczI18n['crop.hint_html'])||'Drag to position · zoom with the slider or pinch. Only what is inside the outline will be printed.') + '</p>' +
        '<p class="vlc-warn" hidden>' + ((window.vczI18n&&window.vczI18n['crop.low_res_html'])||'This photo has low resolution for this size — it may print slightly blurry. A larger photo is recommended.') + '</p>' +
      '</div>';

    var stage = container.querySelector('.vlc-stage');
    var img   = container.querySelector('.vlc-img');
    var paths = container.querySelectorAll('.vlc-ov path');
    var zoom  = container.querySelector('.vlc-zoom');
    var rotB  = container.querySelector('.vlc-rot');
    var warn  = container.querySelector('.vlc-warn');
    var h = V / 2;
    paths[0].setAttribute('d', 'M' + (-h) + ' ' + (-h) + 'H' + h + 'V' + h + 'H' + (-h) + 'Z' + pathD(cut));
    paths[1].setAttribute('d', pathD(cut));

    var nw = 0, nh = 0;
    var st = { x: 0, y: 0, w: 0, rot: 0 };   /* mm; w = largura da imagem no seu próprio eixo */
    /* opts.url: imagem já no servidor (ex.: HEIC convertido para JPEG — o browser não abre HEIC) */
    var ownUrl = !opts.url;
    var url = opts.url || URL.createObjectURL(opts.file);

    function extents(w, rot) {               /* tamanho da imagem rodada, em mm */
      var hh = w * nh / nw;
      return rot % 180 === 0 ? { ew: w, eh: hh } : { ew: hh, eh: w };
    }
    function minW(rot) {                     /* menor largura que cobre a forma com sangria */
      var e = extents(1, rot);
      return Math.max(bb.w / e.ew, bb.h / e.eh);
    }
    function clamp() {
      var mw = minW(st.rot);
      st.w = Math.min(Math.max(st.w, mw), mw * MAX_ZOOM);
      var e = extents(st.w, st.rot);
      /* a forma (com sangria) tem de ficar sempre coberta pela imagem */
      var cx = (bb.x0 + bb.x1) / 2, cy = (bb.y0 + bb.y1) / 2;
      var mx = (e.ew - bb.w) / 2, my = (e.eh - bb.h) / 2;
      st.x = Math.min(Math.max(st.x, cx - mx), cx + mx);
      st.y = Math.min(Math.max(st.y, cy - my), cy + my);
    }
    function render() {
      if (!nw) return;
      var k = stage.clientWidth / V;         /* px por mm */
      img.style.width = (st.w * k) + 'px';
      img.style.transform = 'translate(-50%,-50%) translate(' + (st.x * k) + 'px,' + (st.y * k) + 'px) rotate(' + st.rot + 'deg)';
      zoom.value = (st.w / minW(st.rot)).toFixed(2);
      var dpi = nw / (st.w / 25.4);
      warn.hidden = dpi >= MIN_DPI;
    }
    function changed() { clamp(); render(); if (opts.onChange) opts.onChange(api.get()); }

    img.onload = function () {
      nw = img.naturalWidth; nh = img.naturalHeight;
      st.w = minW(0); st.x = 0; st.y = 0; st.rot = 0;
      changed();
    };
    img.onerror = function () {
      if (opts.onError) opts.onError(((window.vczI18n&&window.vczI18n['crop.open_error_html'])||'We could not open this photo. Please use a JPG or PNG.'));
    };
    img.src = url;

    /* ── Interação: arrastar (1 dedo / rato), pinch (2 dedos), roda do rato ── */
    var ptrs = {}, last = null;
    function pts() { return Object.keys(ptrs).map(function (k) { return ptrs[k]; }); }
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
    function zoomBy(f) { st.w *= f; changed(); }

    stage.addEventListener('pointerdown', function (e) {
      stage.setPointerCapture(e.pointerId);
      ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
      last = null;
    });
    stage.addEventListener('pointermove', function (e) {
      if (!ptrs[e.pointerId] || !nw) return;
      var prev = pts();
      ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
      var now = pts();
      var k = stage.clientWidth / V;
      if (now.length === 1) {
        var p = prev[0];
        st.x += (e.clientX - p.x) / k;
        st.y += (e.clientY - p.y) / k;
        changed();
      } else if (now.length >= 2) {
        var d = dist(now[0], now[1]);
        if (last) zoomBy(d / last);
        last = d;
      }
    });
    function up(e) { delete ptrs[e.pointerId]; last = null; }
    stage.addEventListener('pointerup', up);
    stage.addEventListener('pointercancel', up);
    stage.addEventListener('wheel', function (e) {
      if (!nw) return;
      e.preventDefault();
      zoomBy(Math.exp(-e.deltaY * 0.0015));
    }, { passive: false });
    zoom.addEventListener('input', function () { st.w = minW(st.rot) * parseFloat(zoom.value); changed(); });
    rotB.addEventListener('click', function () {
      var z = st.w / minW(st.rot);
      st.rot = (st.rot + 90) % 360;
      st.w = minW(st.rot) * z;
      changed();
    });
    var ro = window.ResizeObserver ? new ResizeObserver(render) : null;
    if (ro) ro.observe(stage);

    var api = {
      get: function () {
        if (!nw) return null;
        var r = function (v) { return Math.round(v * 1000) / 1000; };
        return { v: 1, shape: opts.shape, mirror: opts.mirror ? 1 : 0, x: r(st.x), y: r(st.y), w: r(st.w), rot: st.rot, nw: nw, nh: nh };
      },
      destroy: function () {
        if (ro) ro.disconnect();
        if (ownUrl) URL.revokeObjectURL(url);
        container.innerHTML = '';
      },
    };
    return api;
  }

  window.VCZLocketCrop = { mount: mount, shapes: SHAPES };
})();
